import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closePopup } from '../../Modal/action';
import './style.scss';

class SuccesssModal extends Component {
    
    render() {
        const { title, description, closePopup, yesAction, success, message } = this.props;
        return (
            <div>
                <div className='popupOuter'>
                    <div className='popupSec' style={{textAlign: 'center'}}>
                        {success ? <div className='success-dialog'>
                            <img src="/images/Success.svg" alt="success" />
                            <h4>Success!</h4>
                            <p>{message}</p>
                            <a href="/">Back to Homepage</a>
                        </div> : 
                        <div className='success-dialog fail'>
                            <img src="/images/Failure.svg" alt="fail" />
                            <h4>Unsuccessfull!!</h4>
                            <p>{message}</p>
                            <a href="/">Back to Homepage</a>
                        </div>}
                    </div>
                </div>
                <div className='popup_overlay black_overlay' />
            </div>
        );
    }
}


const mapDispatchToProps = (dispatch) => ({
    closePopup: bindActionCreators(closePopup, dispatch),
});

export default connect('',mapDispatchToProps)(SuccesssModal);
